/* Importante: Sempre adicionar novos objectos com enabled false */
export default [
  {
    id: 'mainMenu',
    tab: 'INICIAL',
    icon: 'fa fa-bars',
    enabled: false,
    items: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        icon: 'fa fa-tachometer-alt',
        link: '/dashboard',
        enabled: false,
        submenu: false
      },
      {
        id: 'organization',
        title: 'Organização',
        icon: 'fa fa-building',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'schedules',
            title: 'Agendamentos',
            icon: 'fa fa-calendar-alt',
            link: '/schedules',
            enabled: false
          },
          {
            id: 'clients',
            title: 'Clientes',
            icon: 'fa fa-user-friends',
            link: '/clients',
            enabled: false
          },
          {
            id: 'departments',
            title: 'Departamentos',
            icon: 'fa fa-plus-square',
            link: '/departments',
            enabled: false
          },
          {
            id: 'companies',
            title: 'Empresas',
            icon: 'fa fa-city',
            link: '/companies',
            enabled: false
          },
          {
            id: 'permissionsGroup',
            title: 'Grupo de Permissões',
            icon: 'fa fa-user-shield',
            link: '/permissions_group',
            enabled: false
          },
          {
            id: 'occurrences',
            title: 'Ocorrências',
            icon: 'fa fa-file-medical-alt',
            link: '/occurrences',
            enabled: false
          },
          {
            id: 'typeSchedules',
            title: 'Tipo de Agendamentos',
            icon: 'fa fa-exclamation-triangle',
            link: '/type_schedules',
            enabled: false
          },
          {
            id: 'typeOccurrences',
            title: 'Tipo de Ocorrências',
            icon: 'fa fa-exclamation-triangle',
            link: '/type_occurrences',
            enabled: false
          },
          {
            id: 'users',
            title: 'Usuários',
            icon: 'fa fa-users',
            link: '/users',
            enabled: false
          }
        ]
      },
      {
        id: 'petShop',
        title: 'Pet Shop',
        icon: 'fa fa-store-alt',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'species',
            title: 'Espécies',
            icon: 'fa fa-dna',
            link: '/species',
            enabled: false
          },
          {
            id: 'pets',
            title: 'Pets',
            icon: 'fa fa-paw',
            link: '/pets',
            enabled: false
          },
          {
            id: 'breeds',
            title: 'Raças',
            icon: 'fa fa-file-contract',
            link: '/breeds',
            enabled: false
          },
          {
            id: 'veterinarians',
            title: 'Veterinários',
            icon: 'fas fa-syringe',
            link: '/veterinarians',
            enabled: false
          }
        ]
      },
      {
        id: 'productsAndServices',
        title: 'Produtos / Serviços',
        icon: 'fa fa-hand-holding-usd',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'categories',
            title: 'Categorias',
            icon: 'fa fa-sitemap',
            link: '/categories',
            enabled: false
          },
          {
            id: 'manufacturers',
            title: 'Fabricantes',
            icon: 'fa fa-industry',
            link: '/manufacturers',
            enabled: false
          },
          {
            id: 'suppliers',
            title: 'Fornecedores',
            icon: 'fa fa-warehouse',
            link: '/suppliers',
            enabled: false
          },
          {
            id: 'products',
            title: 'Produtos',
            icon: 'fa fa-barcode',
            link: '/products',
            enabled: false
          },
          {
            id: 'services',
            title: 'Serviços',
            icon: 'fa fa-user-cog',
            link: '/services',
            enabled: false
          }
        ]
      },
      {
        id: 'tax',
        title: 'Fiscal',
        icon: 'fa fa-money-check-alt',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'codesNCM',
            title: 'Códigos NCM',
            icon: 'fa fa-barcode',
            link: '/codes_ncm',
            enabled: false
          }
        ]
      },
      {
        id: 'callCenter',
        title: 'Call Center',
        icon: 'fa fa-phone-square',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'pabxs',
            title: 'PABX',
            icon: 'fa fa-server',
            link: '/pabxs',
            enabled: false
          },
          {
            id: 'networksGroup',
            title: 'Grupo de Tronco',
            icon: 'fa fa-sitemap',
            link: '/networks_group',
            enabled: false
          },
          {
            id: 'devices',
            title: 'Dispositivos',
            icon: 'fa fa-tty',
            link: '/devices',
            enabled: false
          },
          {
            id: 'groupsConfig',
            title: 'Grupos',
            icon: 'fa fa-cubes',
            link: '/groups_config',
            enabled: false
          },
          {
            id: 'status',
            title: 'Status',
            icon: 'fas fa-hourglass-start',
            link: '/status',
            enabled: false
          },
          {
            id: 'expedients',
            title: 'Expedientes',
            icon: 'far fa-calendar-alt',
            link: '/expedients',
            enabled: false
          }
        ]
      },
      {
        id: 'reports',
        title: 'Relatórios',
        icon: 'fa fa-file-alt',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'usersReports',
            title: 'Usuários',
            icon: 'fa fa-user',
            link: '/reports/users',
            enabled: false
          },
          {
            id: 'eventsReports',
            title: 'Eventos',
            icon: 'fa fa-fax',
            link: '/reports/events',
            enabled: false
          },
          {
            id: 'groupsReports',
            title: 'Grupos',
            icon: 'fa fa-cube',
            link: '/reports/groups',
            enabled: false
          }
        ]
      },
      {
        id: 'recorder',
        title: 'Gravador',
        icon: 'fa fa-microphone',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'recorderIp',
            title: 'IP',
            icon: 'fas fa-mobile-alt',
            link: '/recorder/ip',
            enabled: false
          },
          {
            id: 'recorderAnalogic',
            title: 'Analógica',
            icon: 'fas fa-phone',
            link: '/recorder/analogic',
            enabled: false
          },
          {
            id: 'recorderRecordings',
            title: 'Gravação',
            icon: 'fas fa-play-circle',
            link: '/recorder/recordings',
            enabled: false
          }
        ]
      },
      {
        id: 'ivr',
        title: 'URA',
        icon: 'fas fa-play',
        link: '#',
        enabled: false,
        submenu: true,
        items: [
          {
            id: 'ivrs',
            title: 'Áudios',
            icon: 'fas fa-music',
            link: '/ivrs',
            enabled: false
          },
          {
            id: 'ivrsConfig',
            title: 'Configurações',
            icon: 'fas fa-cogs',
            link: '/ivrs/config',
            enabled: false
          }
        ]
      }
    ]
  },
  {
    id: 'group',
    tab: 'STATUS DO GRUPO',
    icon: 'fa fa-exchange-alt',
    enabled: false
  },
  {
    id: 'extension',
    tab: 'LOGIN / LOGOUT NO RAMAL',
    icon: 'fa fa-phone',
    enabled: false
  },
  {
    id: 'callHistory',
    tab: 'HISTÓRICO DE LIGAÇÕES',
    icon: 'fa fa-clock',
    enabled: false
  }
];

export const idPermissionsGroup4Case = '6009835e52374f37e8ec6be1';

export const idCompany4Case = '5ffcc0623afc2177041c315d';
